import _ from 'lodash';
import managementTemplate from './rcuManagement.html';
import queueClearModalTemplate from './rcuQueueClearModal.html';

export default {
  name: 'rcuManagementComponent',
  template: managementTemplate,
  controller: RcuManagementController,
  controllerAs: 'RcuManagementCtrl'
};

/* @ngInject */
function RcuManagementController(
  $sails,
  $timeout,
  $uibModal,
  $log,
  RcuManagementService,
  RcuInfoService,
  EquipmentInfoService
) {
  const vm = this;

  // private variables
  let rcus;
  let cameras;
  const rcuMappings = {};
  const defaultGridSettings = {
    enableGridMenu: true,
    enableColumnMenus: false,
    enableFiltering: true,
    showGridFooter: true,
    showColumnFooter: true,
    enableRowSelection: true,
    enableSelectAll: true,
    multiSelect: true,
    modifierKeysToMultiSelect: true,
    gridMenuShowHideColumns: true,
    enableRowHeaderSelection: false,
    enableColumnResizing: true,
    exporterMenuPdf: false,
    exporterMenuCsv: true,
    exporterMenuExcel: false,
    exporterMenuAllData: true,
    exporterMenuVisibleData: true,
    exporterMenuSelectedData: true
  };

  // Used to order column objects
  let _oc = 0;

  // Columns ref for summary grid
  let rcuSummaryGridColumns = [];

  const millitime = 700;

  // public variables
  vm.allSelected = { rcuGridApi: false };

  vm.jobsGrid = _.defaults({
    enableRowSelection: false,
    columnDefs: [
      toColObj('name', 'Job Name', 'string'),
      toColObj('active', 'Active', 'number'),
      toColObj('waiting', 'Waiting', 'number'),
      toColObj('failed', 'Failed', 'number'),
      toColObj('completed', 'Completed', 'number')
    ],
    onRegisterApi(gridApi) {
      vm.jobsGridApi = gridApi;
      $timeout(() => {
        // this call fixes the issue with the grid rendering smaller on page load
        vm.jobsGridApi.core.handleWindowResize();
      }, millitime);
    }
  }, defaultGridSettings);

  // Defines the checkboxes to display for this grid. The match property is used
  // as a regex to match field names. The Model property is used to indicate which
  // column contains the controlling model
  vm.rcuSummaryGridCheckboxes = [{
    name: 'Samba',
    match: 'samba',
    model: 'version.samba.samba'
  }, {
    name: 'IP and Port',
    match: 'ip|port',
    model: 'ip'
  }, {
    name: 'State',
    match: 'state|onnect|synchronized',
    model: 'state'
  }, {
    name: 'Versions',
    match: 'version',
    model: 'version.dnversion'
  }, {
    name: 'Equipment',
    match: 'equipment',
    model: 'equipment.length'
  }];

  // Key our columns so we can modify the objects easily.
  vm.rcuSummaryGridColumnDefs = {
    name: toColObj('name', 'RCU', 'string'),
    id: toColObj('id', 'ID', 'string'),
    ip: toColObj('ip', 'IP', 'string', true),
    port: toColObj('port', 'Port', 'string', true),
    state: toColObj('state', 'State', 'string', true),
    lastConnect: toColObj('lastConnect', 'Last Connect', 'string', true),
    lastDisconnect: toColObj('lastDisconnect', 'Last Disconnect', 'string', true),
    synchronized: toColObj('synchronized', 'Synced', 'string', true),
    'equipment.length': toColObj('equipment.length', 'No. Equipment', 'string', true),
    'version.dnversion': toColObj('version.dnversion', 'Device Version', 'string'),
    'version.node': toColObj('version.node', 'Node Version', 'string'),
    'version.npm': toColObj('version.npm', 'NPM version', 'string'),
    'version.distro': toColObj('version.distro', 'Distro', 'string'),
    'version.board': toColObj('version.board.model', 'Model', 'string'),
    'version.release': toColObj('version.release', 'Kernel', 'string'),
    'version.branch': toColObj('version.branch', 'Branch', 'string'),
    'version.hash': toColObj('version.hash', 'Hash', 'string'),
    'version.pm2': toColObj('version.pm2', 'PM2', 'string'),
    'version.picoFirmware': toColObj('version.picoFirmware', 'upsHat Version', 'string'),
    'version.samba.samba': toColObj('version.samba.samba', 'Samba', 'string', true),
    'version.samba.smbd': toColObj('version.samba.smbd', 'smbd', 'string', true),
    'version.samba.nmbd': toColObj('version.samba.nmbd', 'nmbd', 'string', true)
  };
  rcuSummaryGridColumns = _.sortBy(_.values(vm.rcuSummaryGridColumnDefs), '_order');

  vm.rcuSummaryGrid = _.defaults({
    enableRowSelection: false,
    columnDefs: rcuSummaryGridColumns,
    onRegisterApi(gridApi) {
      vm.rcuSummaryGridApi = gridApi;
      $timeout(() => {
        // this call fixes the issue with the grid rendering smaller on page load
        vm.rcuSummaryGridApi.core.handleWindowResize();
      }, millitime);
    }
  }, defaultGridSettings);

  vm.cameraGrid = _.defaults({
    enableRowSelection: false,
    columnDefs: [
      toColObj('name', 'Camera', 'string'),
      toColObj('id', 'ID', 'string'),
      toColObj('properties.model', 'Model', 'string'),
      toColObj('properties.serial', 'Serial Number', 'string'),
      toColObj('properties.firmware', 'Firmware', 'string')
    ],
    onRegisterApi(gridApi) {
      vm.cameraGridApi = gridApi;
      $timeout(() => {
        // this call fixes the issue with the grid rendering smaller on page load
        vm.cameraGridApi.core.handleWindowResize();
      }, millitime);
    }
  }, defaultGridSettings);

  vm.rcuGrid = _.defaults({
    columnDefs: [
      toColObj('name', 'Name', 'string'),
      toColObj('_id', 'ID', 'string'),
      toColObj('ip', 'IP', 'string'),
      toColObj('port', 'Port', 'number'),
      toColObj('active', 'Active', 'number'),
      toColObj('waiting', 'Waiting', 'number'),
      toColObj('longActive', 'Long Active', 'number'),
      toColObj('longWaiting', 'Long Waiting', 'number')
    ],
    onRegisterApi(gridApi) {
      vm.rcuGridApi = gridApi;
      $timeout(() => {
        // this call fixes the issue with the grid rendering smaller on page load
        vm.rcuGridApi.core.handleWindowResize();
      }, millitime);
    }
  }, defaultGridSettings);

  // public functions
  vm.$onInit = init;
  vm.$onDestroy = () => RcuInfoService.unsubscribeToAdmin;
  vm.exportRcus = exportRcus;
  vm.rcuQueueClearModal = rcuQueueClearModal;
  vm.filterSummaryField = filterVersionField;


  function init() {
    RcuManagementService.getData()
      .then((resp) => {
        const data = resp;
        const rcuCombined = {
          name: 'rcuCombined',
          active: 0,
          waiting: 0,
          failed: 0,
          completed: 0
        };
        const longCombined = {
          name: 'longCombined',
          active: 0,
          waiting: 0,
          failed: 0,
          completed: 0
        };
        _.forEach(data.rcu, (rcu) => {
          rcuCombined.active += rcu.active;
          rcuCombined.waiting += rcu.waiting;
          rcuCombined.failed += rcu.failed;
          rcuCombined.completed += rcu.completed;

          longCombined.active += rcu.longActive;
          longCombined.waiting += rcu.longWaiting;
          longCombined.failed += rcu.longFailed;
          longCombined.completed += rcu.longCompleted;
        });

        data.aggregate.unshift(longCombined);
        data.aggregate.unshift(rcuCombined);
        vm.jobsGrid.data = data.aggregate;
        vm.rcuGrid.data = data.rcu;
      })
      .catch(() => {
        $log.error('Could not load Job Server data');
      })
      .then(setupListeners);

    RcuInfoService.subscribeToAdmin();

    RcuInfoService.getAllRcus()
      .then((resp) => {
        rcus = resp;
        vm.rcuSummaryGrid.data = rcus;
      });

    EquipmentInfoService.getEquipmentByType('cameras')
      .then((resp) => {
        cameras = resp;
        vm.cameraGrid.data = cameras;
      });
  }

  function setupListeners() {
    $sails.on('aggregateUpdate', (data) => {
      for (let i = 0; i < vm.jobsGrid.data.length; i++) {
        if (vm.jobsGrid.data[i].name === data.name) {
          _.forEach(data, (value, key) => {
            vm.jobsGrid.data[i][key] = value;
          });
          break;
        }
      }
    });
    $sails.on('rcuUpdate', (data) => {
      if (data.hasOwnProperty('active')) {
        for (let i = 0; i < vm.jobsGrid.data.length; i++) {
          if (vm.jobsGrid.data[i].name === 'rcuCombined') {
            vm.jobsGrid.data[i].active += data.active - rcuMappings[data._id].active;
            vm.jobsGrid.data[i].waiting += data.waiting - rcuMappings[data._id].waiting;
            vm.jobsGrid.data[i].failed += data.failed - rcuMappings[data._id].failed;
            vm.jobsGrid.data[i].completed += data.completed - rcuMappings[data._id].completed;
            rcuMappings[data._id].active = data.active;
            rcuMappings[data._id].waiting = data.waiting;
            rcuMappings[data._id].failed = data.failed;
            rcuMappings[data._id].completed = data.completed;
          }
        }
      } else if (data.hasOwnProperty('longActive')) {
        for (let i = 0; i < vm.jobsGrid.data.length; i++) {
          if (vm.jobsGrid.data[i].name === 'longCombined') {
            vm.jobsGrid.data[i].active += data.longActive - rcuMappings[data._id].longActive;
            vm.jobsGrid.data[i].waiting += data.longWaiting - rcuMappings[data._id].longWaiting;
            vm.jobsGrid.data[i].failed += data.longFailed - rcuMappings[data._id].longFailed;
            vm.jobsGrid.data[i].completed += data.longCompleted - rcuMappings[data._id].longCompleted;
            rcuMappings[data._id].longActive = data.longActive;
            rcuMappings[data._id].longWaiting = data.longWaiting;
            rcuMappings[data._id].longFailed = data.longFailed;
            rcuMappings[data._id].longCompleted = data.longCompleted;
          }
        }
      }
      for (let i = 0; i < vm.rcuGrid.data.length; i++) {
        if (vm.rcuGrid.data[i]._id === data._id) {
          _.forEach(data, (dataProperty, key) => {
            vm.rcuGrid.data[i][key] = dataProperty;
          });
          break;
        }
      }
    });
  }

  function toColObj(field, displayName, type, hidden) {
    return {
      field,
      displayName,
      type,
      visible: !hidden,
      _order: _oc++,
      enableCellEdit: false
    };
  }

  function filterVersionField(match, model) {
    _.forEach(rcuSummaryGridColumns, (col) => {
      if (col.field.match(match)) {
        // Set all matching colums to match the model,
        // cant just flip because you flip the controlling 'model' twice
        col.visible = vm.rcuSummaryGridColumnDefs[model].visible;
      }
    });
    vm.rcuSummaryGridApi.grid.refresh();
  }

  function rcuQueueClearModal() {
    $uibModal.open({
      template: queueClearModalTemplate,
      controllerAs: 'RcuQModalCtrl',
      controller: 'RcuQueueClearModalController',
      size: 'lg',
      resolve: {
        rcuArray() {
          return vm.rcuGrid.selection ? _.map(vm.rcuGrid.selection.getSelectedRows(), '_id') : [];
        }
      }
    });
  }

  function exportRcus() {
    let str = '';
    rcus.forEach((rcu) => {
      const name = rcu.name.contains(',') ? `"${rcu.name}"` : rcu.name;
      const params = [name, rcu.ip, rcu.port, rcu.id];
      str += `${params.join(',')}\n`;
    });
    const blob = new Blob([str], { type: 'data:text/csv;charset=utf-8' });
    saveAs(blob, 'RCUs.csv');
  }
}
